import React from 'react'
import GenericGrid from '../../sharedcomponents/5templates/commonGrid/GenericGrid'
import GridWrapper from '../../sharedcomponents/5templates/commonGrid/GridWrapper'
import useGridWrapper from '../../sharedcomponents/5templates/commonGrid/useGridWrapper'
import useDatazone from './useDatazone'

const GeoZones = () => {
  const defaultFetchParameter = {
    include: ['counts'],
    sort: '+name',
    type: 'geo',
    page: 0,
    per_page: 20
  }
  const {
    loadDataZones,
    bulkUpdateDataZonesCallBack
  } = useDatazone({})

  const {
    editMode,
    setEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    deletionChanges,
    deleteCallBack,
    activationChanges,
    activationCallBack,
    detailCallBack,
    addCallBack,
    handSaveCallback,
    isGridDirty
  } = useGridWrapper('Geo Zone', bulkUpdateDataZonesCallBack)

  const visibleColumns = [
    { field: 'name', headerName: 'Name', width: 250, sortable: true },
    {
      field: 'total_operational_groups',
      headerName: 'Operational Groups',
      width: 150,
      sortable: true
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 300,
      sortable: true
    },
    {
      field: 'active',
      headerName: 'Status',
      width: 150,
      sortable: true,
      isToggle: true
    }
  ]

  const fetchCallBack = async arg => {
    const {
      data: { data, pagination, sort } = {
        data: [],
        pagination: {},
        sort: {}
      },
      isError,
      isLoading,
      isFetching
    } = await loadDataZones(arg)
    // transform the server-provided array for display
    const rows = []
    data.forEach(one => {
      rows.push({
        id: one.id, //please note, the underlying datagrid assumes the id column is always called id
        name: one.name,
        description: one.description,
        total_operational_groups: one.stats?.find(r => r.type === 'operational')?.count,
        active: one.suspended_at ? false : true,
        is_system: one.is_system
      })
    })

    return {
      newRows: rows,
      newPagination: pagination,
      newSort: sort,
      newLoading: isLoading || isFetching,
      newError: isError
    }
  }

  //save changes if user confirms

  const handleSave = () => {
    if (handSaveCallback()) {
      // call the api to actually save deletion and activation changes
      console.log(activationChanges)
      console.log(deletionChanges)
      //destroy all local state and refetch
    }
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div style={{ height: '100%', width: '100%' }}>
        <GridWrapper
          header={'Geo Zones'}
          editMode={editMode}
          setEditMode={setEditMode}
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          isGridDirty={isGridDirty}
          handleSave={handleSave}
          addCallBack={addCallBack}
          containedEntityType={'geo'}
          defaultType={'poly'}
        >
          <GenericGrid
            initialFetchParameters={defaultFetchParameter}
            visibleColumns={visibleColumns}
            editMode={editMode}
            fetchCallBack={fetchCallBack}
            detailCallBack={detailCallBack}
            deleteCallBack={deleteCallBack}
            activationCallBack={activationCallBack}
            deletionChanges={deletionChanges}
            activationChanges={activationChanges}
          />
        </GridWrapper>
      </div>
    </div>
  )
}
export default React.memo(GeoZones)
